import { Component, lazy } from 'react';
import { Navigate } from 'react-router-dom';
import LogIn from '../Authentication/components/LogIn';
import LogOut from '../Authentication/components/LogOut';
import ExternalLogIn from '../Authentication/containers/ExternalLogIn';
import Mapper from '../Forms/containers/Mapper';
import Unauthorized from './views/Unauthorized';
import formDefinitions from '../Forms/paths';
import List from '../List/containers/List';
import { formData } from "../util/enums";

const ContactMaintenance = lazy(() => import('../Maintenance/containers/ContactMaintenance'));
const FacultyMaintenance = lazy(() => import('../Maintenance/containers/FacultyMaintenance'));
const PendingMaintenance = lazy(() => import('../Maintenance/containers/PendingMaintenance'));
const ContactSearch = lazy(() => import('../Search/containers/ContactSearch'));
const FacultySearch = lazy(() => import('../Search/containers/FacultySearch'));
const FormsSearch = lazy(() => import('../Search/containers/FormsSearch'));
const GraduationRecordsSearch = lazy(() => import('../Search/containers/GraduationRecordsSearch'));
const Form = lazy(() => import('../Form/containers/'));
const FormLanding = lazy(() => import('../Form/containers/Landing'));
const FormStatus = lazy(() => import('../Form/containers/Status'));
const Dashboard = lazy(() => import('../Dashboard/containers'));
const Tasks = lazy(() => import('../Tasks/containers'));
const ProxyAsStudent = lazy(() => import('../Student/containers/Proxy'));

const getTitle = (params) => {
    const formType = params?.match?.params?.formType
    return formDefinitions?.[formType]?.title
}

const getListTitle = (params) => {
    const listType = params?.match?.params?.listType
    return formData?.[listType]?.area
}

const EXTERNAL_PATHS = [
    { title: 'Tasks', path: '/', Component: (props) => <Tasks  {...props} /> },
    { title: 'Legacy Redirect', path: "/grad-forms", Component: () => <Navigate to="/" replace /> },
    { title: 'Tasks', path: '/tasks', Component: (props) => <Tasks  {...props} /> },
    { title: (params) => {
        let heading = getTitle(params)
        return `View ${heading ? heading + " " : ""}Form`
    }, path: '/form/:formType/view/:formId/:osuid?', Component: Form },
    { title: 'Form Status', path: '/form/:formType/status/:formId/:osuid?', Component: (props) => <FormStatus {...props} />, titleProps: { className: 'sr-only' } }
]

const FormComponent = (props) => {
    const formType = props?.match?.params?.formType;
    const formDefinition = (formDefinitions?.[formType] ?? {});
    const FormComponent = formDefinition?.form;
    if(FormComponent) {
        return (<FormComponent {...props} Component={Mapper} />);
    } else {
        return (<Mapper {...props} />);
    }
}

export const PARTIAL_PATHS = {
    create:  `create`,
    edit: `edit`
}

const PATHS = [
    { title: 'Home', path: '/', Component: (props) => <Dashboard {...props} />, titleProps: { className: 'sr-only' } },
    { title: 'Legacy Redirect', path: "/grad-forms", Component: () => <Navigate to="/" replace /> },
    { title: 'Tasks', path: '/tasks', Component: (props) => <Tasks  {...props} /> },
    { title: 'Contact Maintenance', path: '/admin/contact-maintenance', Component: ContactMaintenance },
    { title: 'Faculty Maintenance', path: '/admin/faculty-maintenance', Component: FacultyMaintenance },
    { title: 'Proxy As Student', path: '/admin/proxy-as-student', Component: ProxyAsStudent },
    { title: (params) => {
        let heading = getListTitle(params) 
        return `${heading ? heading : "List"}`
    }, path: '/forms/:listType', Component: List },
    { title: 'Pending Maintenance', path: '/admin/pending-maintenance', Component: PendingMaintenance },
    { title: (params) => {
        let heading = getTitle(params)
        return `Create${heading ? ` ${heading}` : ""}`
    }, path: '/form/:formType/' + PARTIAL_PATHS.create, Component: FormComponent },
    { title: (params) => {
        let heading = getTitle(params)
        return `View${heading ? ` ${heading}` : ""}`
    }, path: '/form/:formType/view/:formId/:osuid?', Component: Form },
    { title: (params) => {
        let heading = getTitle(params)
        return `Edit${heading ? ` ${heading}` : ""}`
    }, path: '/form/:formType/' + PARTIAL_PATHS.edit + '/:formId/:osuid?', Component: FormComponent },
    { title: 'Form Status', path: '/form/:formType/status/:formId/:osuid?', Component: (props) => <FormStatus {...props} />, titleProps: { className: 'sr-only' } },
    { title: (params) => {
        const heading = getTitle(params);
        return (heading ? `${heading}` : ""); 
    }, path: "/form/:formType", Component: FormLanding },
    { title: 'Contact Search', path: '/search/contact', Component: ContactSearch },
    { title: 'Faculty Search', path: '/search/faculty', Component: FacultySearch },
    { title: 'Forms Search', path: '/search/forms', Component: FormsSearch },
    { title: 'Graduation Records Search', path: '/search/graduationrecords', Component: GraduationRecordsSearch }
];

export const LOGIN_ROUTE = '/login'
export const LOGIN_ROUTE_EXTERNAL = '/external/login'
export const UNAUTHORIZED_ROUTE = '/unauthorized'
const authenticationFlowPaths = [
    { path: LOGIN_ROUTE_EXTERNAL, Component: ExternalLogIn},
    { path: LOGIN_ROUTE, Component: LogIn },
    { path: '/logout', Component: LogOut },
    { path: UNAUTHORIZED_ROUTE, Component: Unauthorized }
];

export {
    authenticationFlowPaths,
    EXTERNAL_PATHS,
    PATHS as default,
};